export default __webpack_public_path__ + "static/Metal_Windowframe-5a36c5d0dbfb6bfbd9e0eb93b1c75fc1.png";